export const getFiscalShortName = (fiscalType: string) => {
  return {
    label: {
      eng: 'Short company name*',
      rus: 'Краткое название компании*',
      kz: 'Аты қысқартылған*',
    },
    placeholder: {
      eng: `${
        '«MPK»'
      }`,
      rus: `${
        '«MПK»'
      }`,
      kz: `${
        '«MPK»'
      }`,
    },
  }
}
